import http from "./httpService";

const apiEndpoint = process.env.REACT_APP_API_IDENTITY_URL + "/account";

async function ForgotPassword(data) {
  return await http.post(apiEndpoint + "/forgotpassword", data);
}

async function ChangePassword(data) {
  http.addBearerAuthorization();
  return await http.post(apiEndpoint + "/ChangePassword", data);
}

async function Confirm(data) {
  return await http.post(apiEndpoint + "/Confirm", data);
}

async function SetPassword(data) {
  return await http.post(apiEndpoint + "/setpassword", data);
}

async function Me() {
  http.addBearerAuthorization();
  return await http.get(apiEndpoint + "/me");
}

async function EditMe(details) {
  http.addBearerAuthorization();
  return await http.put(apiEndpoint + "/me", details);
}

export default {
  Confirm,
  ForgotPassword,
  ChangePassword,
  Me,
  EditMe,
  SetPassword
};
